module.exports = __webpack_public_path__ + "static/media/C3.e0fd0c95.jpg";